@if (isLoading()) {
  <div class="bai-suggestions__loading">
    <p-skeleton width="60%" height="1.75rem" />
  </div>
} @else if (hasError()) {
  <!-- collapsed — zero height, no visible error to keep UI clean -->
} @else if (!isEmpty()) {
  <div class="bai-suggestions__chips-row" (click)="$event.stopPropagation()">
    <span class="bai-suggestions__label">
      @if (generating()) {
        ✦ Generating<span class="bai-suggestions__dots" aria-hidden="true"><span></span><span></span><span></span></span>
      } @else {
        ✦ Suggestions
      }
    </span>
    <div class="bai-suggestions__chips" role="group" aria-label="Suggestion quick queries">
      @for (topic of visibleTopics(); track topic.id) {
        <button
          type="button"
          class="bai-suggestions__chip"
          [class.bai-suggestions__chip--selected]="topic.id === selectedTopicId()"
          [attr.title]="topic.label"
          [attr.aria-pressed]="topic.id === selectedTopicId()"
          (click)="onChipClick(topic)"
        >
          <span class="bai-suggestions__chip-text">{{ topic.label }}</span>
        </button>
      }
    </div>

    @if (hasOverflow()) {
      <div class="bai-suggestions__overflow">
        <button
          type="button"
          class="bai-suggestions__more-btn"
          [class.bai-suggestions__more-btn--open]="showOverflow()"
          [attr.aria-expanded]="showOverflow()"
          aria-haspopup="true"
          aria-label="Show more suggestions"
          (click)="toggleOverflow()"
        >
          {{ overflowLabel() }}
          <i
            class="pi bai-suggestions__more-chevron"
            [class.pi-chevron-up]="showOverflow()"
            [class.pi-chevron-down]="!showOverflow()"
            aria-hidden="true"
          ></i>
        </button>

        @if (showOverflow()) {
          <div
            class="bai-suggestions__dropdown"
            role="menu"
            aria-label="Additional suggestions"
          >
            @for (topic of overflowTopics(); track topic.id) {
              <button
                type="button"
                class="bai-suggestions__dropdown-item"
                [class.bai-suggestions__dropdown-item--selected]="topic.id === selectedTopicId()"
                role="menuitem"
                [attr.aria-pressed]="topic.id === selectedTopicId()"
                [attr.title]="topic.label"
                (click)="onOverflowTopicClick(topic)"
              >
                {{ topic.label }}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
}
